import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";

export const SignatureDisplay = ({
    signatures,
    isLoading,
    onImageError,
    imageErrors,
    formatDate
}) => {
    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Spinner animation="border" size="sm" />
                <span>Loading signatures...</span>
            </div>
        );
    }

    if (!signatures || signatures.length === 0) {
        return <p className="text-muted">No signatures found for this recall</p>;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {signatures.map((sig) => {
                const hasError = imageErrors?.[sig.id] || false;
                return (
                    <div
                        key={sig.id}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            padding: '10px',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            backgroundColor: '#f9f9f9',
                            flexWrap: 'wrap'
                        }}
                    >
                        {/* Signature Image */}
                        <div style={{ flexShrink: 0 }}>
                            {sig.doc_image && !hasError ? (
                                <img
                                    src={sig.doc_image_url}
                                    alt="Signature"
                                    onClick={() => window.open(sig.doc_image_url, "_blank")}
                                    onError={() => onImageError?.(sig.id)}
                                    crossOrigin="anonymous"
                                    referrerPolicy="no-referrer"
                                    style={{
                                        width: '120px',
                                        height: '60px',
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        padding: '4px',
                                        backgroundColor: '#fff'
                                    }}
                                />
                            ) : (
                                <div style={{
                                    width: '120px',
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#f5f5f5',
                                    color: '#999',
                                    fontSize: '12px'
                                }}>
                                    <span>{hasError ? 'Failed to load' : 'No image'}</span>
                                </div>
                            )}
                        </div>

                        {/* Signature Details */}
                        <div style={{ flex: 1, minWidth: '150px' }}>
                            <div style={{ marginBottom: '4px', fontSize: "14px" }}>
                                <strong>Submitted By:</strong> {sig.submited_by || 'N/A'}
                            </div>
                            <div style={{ fontSize: '14px', color: '#666' }}>
                                <strong>Date:</strong> {formatDate?.(sig.created_at) || sig.created_at}
                            </div>
                        </div>

                        {/* View Full Image Button */}
                        {sig.doc_image && !hasError && (
                            <button
                                onClick={() => window.open(sig.doc_image_url, "_blank")}
                                style={{
                                    padding: '6px 12px',
                                    backgroundColor: '#5b68c3',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <i className="fa fa-external-link-alt" style={{ marginRight: '5px' }}></i>
                                View Full
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

SignatureDisplay.propTypes = {
    signatures: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            recall_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            recall_type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            submited_by: PropTypes.string,
            doc_image: PropTypes.string,
            doc_image_url: PropTypes.string,
            created_at: PropTypes.string,
            updated_at: PropTypes.string
        })
    ),
    isLoading: PropTypes.bool,
    onImageError: PropTypes.func,
    imageErrors: PropTypes.object,
    formatDate: PropTypes.func
};

SignatureDisplay.defaultProps = {
    signatures: [],
    isLoading: false,
    onImageError: () => { },
    imageErrors: {},
    formatDate: (date) => {
        if (!date) return 'N/A';
        return new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
};